import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';
// Import flag SVGs from svg-country-flags package
import gbFlag from 'svg-country-flags/svg/gb.svg'; // British/English flag
import skFlag from 'svg-country-flags/svg/sk.svg'; // Slovak flag
import nlFlag from 'svg-country-flags/svg/nl.svg'; // Dutch flag
import ptFlag from 'svg-country-flags/svg/pt.svg'; // Portuguese flag
import deFlag from 'svg-country-flags/svg/de.svg'; // German flag
import grFlag from 'svg-country-flags/svg/gr.svg'; // Greek flag

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // Flag configuration with language codes
  const languageFlags = [
    { code: 'en', flag: gbFlag, alt: 'UK Flag - English' },
    { code: 'sk', flag: skFlag, alt: 'Slovak Flag - Slovak' },
    { code: 'nl', flag: nlFlag, alt: 'Netherlands Flag - Dutch' },
    { code: 'pt', flag: ptFlag, alt: 'Portuguese Flag - Portuguese' },
    { code: 'de', flag: deFlag, alt: 'German Flag - German' },
    { code: 'el', flag: grFlag, alt: 'Greek Flag - Greek' },
  ];

  return (
    <div className="language-selector">
      {languageFlags.map(({ code, flag, alt }) => (
        <button 
          key={code}
          onClick={() => changeLanguage(code)} 
          className={i18n.language === code ? 'active' : ''}
          title={alt}
        >
          <img src={flag} alt={alt} className="flag-icon" />
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
